<template>
<svg
  class="cam-icon"
  aria-hidden="true"
  :style="{
    width: props.size + 'px',
    height: props.size + 'px',
    color: props.color
  }"
>
  <use :xlink:href="`#icon-${props.name}`" :fill="props.color" />
</svg>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

/**
 * @description: svg图标组件
 * @use {*} <SvgIcon name="home" :size="14" color="red" />
 */
export default defineComponent({
  name: 'CamIcons',
  props: {
    name: {
      type: String,
      required: true,
    },
    size: {
      type: Number,
      'default': 18,
    },
    color: {
      type: String,
      'default': '#000',
    },
  },
  setup(props) {
    return {
      props,
    }
  },
})
</script>
<style scoped>
.cam-icon {
  width: 1em;
  height: 1em;
  vertical-align: middle;
  fill: currentColor;
  overflow: hidden;
}
</style>
